import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getEmailVerifiedStatus, sendVerificationEmail } from "./EmailVerificationAPI"
// import { getEmailVerifiedStatus } from "../PasswordReset/PasswordResetAPI"

// Async Thunk to handle API call
export const verifyEmailAsync = createAsyncThunk("emailVerification/verify", async (_, { rejectWithValue }) => {
  try {
    const response = await sendVerificationEmail()
    return response
  } catch (error) {
    return rejectWithValue(error.message || "Failed to send verification email")
  }
})

export const fetchEmailVerifiedStatus = createAsyncThunk(
  "emailVerification/fetchStatus",
  async (token, { rejectWithValue }) => {
    try {
      const data = await getEmailVerifiedStatus(token)
      return data // API should return { verified: true/false }
    } catch (error) {
      return rejectWithValue(error.message || "Failed to verify email")
    }
  },
)

const emailVerificationSlice = createSlice({
  name: "emailVerification",
  initialState: {
    loading: false,
    success: false,
    error: null,
    status: null,
    verified: false,
  },
  reducers: {
    resetVerificationState: (state) => {
      state.loading = false
      state.success = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyEmailAsync.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = null
      })
      .addCase(verifyEmailAsync.fulfilled, (state) => {
        state.loading = false
        state.success = true
      })
      .addCase(verifyEmailAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(fetchEmailVerifiedStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchEmailVerifiedStatus.fulfilled, (state, action) => {
        state.loading = false
        state.status = action.payload.status
        state.verified = action.payload.verified || false
      })
      .addCase(fetchEmailVerifiedStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetVerificationState } = emailVerificationSlice.actions
export default emailVerificationSlice.reducer
